import { create } from '@edicom/common/element/create';
import { getAllFocusables } from '@edicom/common/element/getAllFocusables';
import { popupManager } from 'edicom';

fbGridPopupDirective.$inject = ['$compile', '$timeout'];

export default function fbGridPopupDirective($compile, $timeout) {
  return {
    restrict: 'E',
    scope: true,

    link,
  };

  function link(scope, element) {
    const elem = element[0];
    let isVisible = false;

    const id = elem.getAttribute('for');
    const eCell = document.getElementById(id);
    const widthGrid = calculateWidthGrid(elem);
    const width = widthGrid - 32 - 32; // margin
    const MAX_WIDTH = '800px';
    const isFullscreen = elem.hasAttribute('fullscreen');
    const isBtnFullscreen = elem.hasAttribute('fullscreen-btn');
    const template = document.getElementById(`${id}_template`);
    const ePopup = isFullscreen
      ? create(
          `<div ec-layout>
            <header ec-header>
              <label>${elem.getAttribute('label') || ''}</label>
            </header>
            <main>${template.innerHTML}</main>
            <footer ec-footer></footer>
          </div>`
        )
      : create(`<div style="width:${width}px;height:auto;max-width:${MAX_WIDTH}">${template.innerHTML}</div>`);

    let eFocusables = [];
    let eFooter;

    const popup = popupManager.create(elem, ePopup, {
      onClickOutside: event => {
        // controlamos si se hace click en el elemento, entonces no hacemos nada
        // dejamos los eventos internos que lo gestionen (ej para el toggle)
        if (eCell.contains(event.target)) {
          return;
        }
        // si es un click fuera del todo, cerramos
        popup.hide();
      },
      isCovering: false,
      align: 'center',
      fullscreen: isFullscreen,
      isBtnClose: isFullscreen,
      isBtnFullscreen,
      hideOnClickOutside: false,
      onShow: () => {
        isVisible = true;
      },
      onHide: () => {
        isVisible = false;
        eCell.parentElement && eCell.parentElement.parentElement && eCell.parentElement.parentElement.focus();
      },
    });

    // exponemos api para FbPopupCellEditor.class.js
    elem.open = open;
    elem.close = close;
    elem.toggle = toggle;
    elem.isVisible = () => isVisible;
    elem.ePopup = ePopup; // se necesita para recuperar el ec-grid-list2 para el flash

    // compilamos con angularjs
    compileAngularjs().then(() => {
      // on init:
      ePopup.addEventListener('keydown', onKey);
      if (isFullscreen) {
        eFooter = ePopup.querySelector('[ec-footer]');
        eFooter.addEventListener('ecFooter:close', onClose);
      }
      if (elem.hasAttribute('opened')) {
        open();
      }
    });

    scope.$on('$destroy', () => {
      ePopup.removeEventListener('keydown', onKey);
      popup.hide();
      if (isFullscreen) {
        eFooter.removeEventListener('ecFooter:close', onClose);
      }
    });

    ////////////////////////////////////////////////////////////////////////////

    function compileAngularjs() {
      return new Promise(resolve => {
        $compile(angular.element(ePopup))(scope);
        $timeout(() => {
          resolve();
        });
      });
    }

    function open() {
      if (popup.isOpen()) {
        return;
      }
      popup.show();
      focusFirst(ePopup);
    }

    function close() {
      popup.hide();
    }

    function toggle() {
      popup.isOpen() ? close() : open();
    }

    function focusFirst(ePopup) {
      $timeout(() => {
        setFooterButtonNotFocusable(ePopup);
        eFocusables = getAllFocusables(ePopup).filter(el => !el.hidden);
        eFocusables.length && eFocusables[0].focus();
      });
    }

    function calculateWidthGrid(elem) {
      const agBodyViewport = elem.closest('.ag-body-viewport');
      if (!agBodyViewport) {
        return 500;
      }
      return agBodyViewport.getBoundingClientRect()?.width;
    }

    function onKey(event) {
      if (event.key === 'Tab') {
        onKeyTab(event);
        return;
      }
      if ('Escape'.includes(event.key)) {
        eCell.dispatchEvent(new KeyboardEvent(event.type, event)); // odeniel emitir evento desde celda
      }
    }

    function onKeyTab(event) {
      eFocusables = getAllFocusables(ePopup).filter(el => !el.hidden);
      const isBeforeFirst = eFocusables[0] === document.activeElement && event.shiftKey;
      const isAfterLast = eFocusables[eFocusables.length - 1] === document.activeElement && !event.shiftKey;
      if (!isBeforeFirst && !isAfterLast) {
        return;
      } // dejamos que el tab se ejecute normalemente
      event.preventDefault();
      event.stopPropagation();
      // @odeniel: paramos la edición para lanzar los eventos que actualizan la celda y/o el grid
      // scope.stopEditing();
      // @odeniel: esperamos angular
      $timeout(() => {
        isBeforeFirst && scope.tabToPreviousCell();
        isAfterLast && scope.tabToNextCell();
      });
    }

    function onClose() {
      close();
    }

    function setFooterButtonNotFocusable(ePopup) {
      if (!isFullscreen) {
        return;
      }
      const button = ePopup.querySelector('[ec-footer] button');
      if (!button) {
        throw new Error('no encontrado el button dentro del ec-footer');
      }
      button.setAttribute('tabindex', '-1');
    }
  }
}
